





























































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Workspace, Summary } from '@/entities';

const namespace: string = "application";

@Component
export default class SubmitComponent extends Vue {

    @State(namespace) application!: Workspace;
    @Getter("rootTemplate", { namespace }) schema: any;
    @Prop() appData!: any;

    /** calculate the margin */
    computedMargin(value: number): string {
        if(value < 25) {
            return 'padleft-0'
        } else if (value < 50){
            return 'padleft-25'
        } else if (value < 75){
            return 'padleft-50'
        } else {
            return 'padleft-75'
        }
    }

    /** get left margin according to the progress */
    get techAppProgressMargin() {
        return this.computedMargin(this.technicalApplicationProgress)
    }

    /** get left margin according to the progress */
    get budgetProgressMargin() {
        return this.computedMargin(this.budgetProgress)
    }

    /** get left margin according to the progress */
    get dueDiligenceProgressMargin() {
        return this.computedMargin(this.dueDiligenceProgress)
    }

    get safeguardProgressMargin() {
        return this.computedMargin(this.safeguardProgress)
    }

    /** get left margin according to the progress */
    get defaultMargin() {
        return this.computedMargin(0)
    }

    /** get the technical application progress from summary */
    get technicalApplicationProgress() {
        let applSummary: Summary = this.$services.summary.getTechnicalApplicationSummary(this.application.technicalApplication.templates, this.appData);
        return applSummary.progress();
    }

    /** get the budget progress from summary */
    get budgetProgress() {
        let bgtSummary: Summary = this.$services.summary.getBudgetSummary(this.application.applicationBudget.templates, this.application.applicationBudget.data);
        return bgtSummary.progress();
    }

    /** get the budget progress from summary */
    get dueDiligenceProgress() {
       let dueDiligenceSummary: Summary = this.$services.summary.getDueDeligenceSummary(this.application.applicantDueDeligence.templates, this.appData);
        return dueDiligenceSummary.progress();
    }

    /** get safeguard progress */
    get safeguardProgress() {
        if(this.schema && this.schema.properties && this.schema.properties['managementSystem']) {
            let safeguardSummary: Summary = this.$services.summary.getSafeguardSummary(this.schema.properties['managementSystem'], this.appData);
            return safeguardSummary.progress();
        } else {
            return 0;
        }        
    }

}
